import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';

export const Impressum = () => {
  return (
    <div className="min-h-screen flex flex-col" data-testid="impressum-page">
      <Navigation />
      
      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#003366] mb-8">Impressum</h1>
          
          <div className="prose prose-lg max-w-none text-slate-700 space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="whitespace-pre-line">
                KayaGroup{'\n'}
                Sinan Kaya / Gürsel Kaya GbR{'\n'}
                {'\n'}
                Am Schwalbengraben 17{'\n'}
                35584 Wetzlar{'\n'}
                Deutschland
              </p>
            </section>

            <section>
              <p className="mt-6">
                <strong>USt-IdNr.:</strong> DE367336194
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">Vertreten durch:</h2>
              <p>
                Sinan Kaya{'\n'}<br />
                Gürsel Kaya
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">Kontakt</h2>
              <p>
                Telefon: <a href="tel:+4916092653278" className="text-[#00BFFF] hover:text-[#003366]">+49 160 92653278</a><br />
                E-Mail: <a href="mailto:fa.kayaclean@gmail.com" className="text-[#00BFFF] hover:text-[#003366]">fa.kayaclean@gmail.com</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</h2>
              <p className="whitespace-pre-line">
                Sinan Kaya{'\n'}
                Am Schwalbengraben 17{'\n'}
                35584 Wetzlar{'\n'}
                Deutschland
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;
